/*=========================================================================================
  File Name: module-confirm-business-actions.js
  Description: Confirm Business Module Actions
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import httpClient from '../../api/axios-httpclient';
import ConfirmBusinessAPI from '@/api/ConfirmBusinessAPI.js';
import InvoiceAPI from '@/api/InvoiceAPI.js';
import DownloadAPI from '@/api/DownloadAPI.js';
import commonFunc from '@/common/commonFunction';
import EventBusGlobal, { GlobalEventName } from '@/sys/eventBusGlobal';
import { NumberRetry, NumberTimeOutRetry } from '@/api/base/base-api';
import { MSEnum } from '@/common/enumeration';
export default {
	/**
	 * Lấy danh sách
	 * @author dqduy 04.12.2024
	 */
	loadListDataAsync: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: `${InvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/getCheckBusiness`,
			params: payload
		});
		if (res.Success && res.Data) {
			context.commit('updateConfirmListBusiness', res.Data);
			return res.Data;
		}
		return null;
	},

	/**
	 * Lấy tổng số bản ghi
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 * @author dqduy 16.12.2024
	 */
	getCheckBusinessTotalPageAsync: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: `${InvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/getCheckBusinessTotal`,
			params: payload
		});
		if (res && res.Success) {
			context.commit('updateConfirmBusinessTotal', res.Data);
			return res.Data;
		}
		return res;
	},

	/**
	 * Lấy tổng số bản ghi của từng tab
	 * @author dqduy 04.12.2024
	 */
	getTotalPageAsync: async function(context, payload) {
		let res = await httpClient.getAsync({
			url: `${InvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/totalBusinessByTab/${payload.InvoiceId}`,
			data: payload
		});
		return res;
	},

	/**
	 * Cập nhật từng ngành nghề kinh doanh, like or dislike
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 * @author dqduy 16.12.2024
	 */
	updateItemBusiness: async function(context, payload) {
		let res = await httpClient.postAsync({
			url: `${InvoiceAPI.getAPIUrlSubParam(commonFunc.getSubParam())}/updateItemBusiness`,
			data: payload
		});
		return res;
	},

	/**
	 * Xuất khẩu excel
	 * @param {*} context
	 * @param {*} payload
	 * @returns
	 * @author dqduy 16.12.2024
	 */
	exportExcel: async function(context, payload) {
		let dateRange = commonFunc.formatDate(new Date(), 'DDMMYYYY_HHmmss');
		let fileName = `Ket_qua_kiem_tra_HHDV_theo_NNKD.xlsx`;
		let ProgressData = {
			percentCompleted: 0,
			fileName: fileName,
			Success: true
		};
		EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
		let res = await httpClient.postAsync({
			url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + '/exportcheckbusiness',
			data: payload
		});
		if (res && res.Success) {
			let tryTime = 0;
			async function download(key) {
				tryTime++;
				let exportFile = await httpClient.getAsync({
					url: DownloadAPI.getAPIUrlSubParam(commonFunc.getSubParam()) + `/${key}/export`,
					responseType: 'arraybuffer',
					onDownloadProgress: function(progressEvent) {
						if (progressEvent.total) {
							var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
							ProgressData = {
								percentCompleted: percentCompleted,
								fileName: fileName,
								Success: true
							};
							EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						}
					}
				});
				if (exportFile instanceof ArrayBuffer) {
					ProgressData = {
						percentCompleted: 100,
						fileName: fileName,
						Success: true
					};
					EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
					commonFunc.downloadByBlob(exportFile, 'application/vnd.ms-excel', fileName);
				} else {
					if (tryTime >= NumberRetry) {
						ProgressData = {
							percentCompleted: 0,
							fileName: fileName,
							Success: false
						};
						EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
						return;
					}
					setTimeout(() => {
						download(key);
					}, NumberTimeOutRetry);
				}
			}
			setTimeout(() => {
				download(res.Data.Key);
			}, NumberTimeOutRetry);
			return res;
		} else {
			ProgressData = {
				percentCompleted: 0,
				fileName: fileName,
				Success: false
			};
			EventBusGlobal.$emit(GlobalEventName.Progress, ProgressData);
			return null;
		}
	}
};
